import { NgModule } from "@angular/core";
import { Location } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { BaseComponent } from "./base/base.component";

const routes: Routes = [
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./../../views/pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "BusSchedule",
        loadChildren: () =>
          import("./../../views/pages/busdetail/addbusdetail.module").then(
            (m) => m.AddbusdetailModule
          ),
      },
      {
        path: "addbusdetail",
        loadChildren: () =>
          import("./../../views/pages/busdetail/addbusdetail.module").then(
            (m) => m.AddbusdetailModule
          ),
      },
        {
          path: "grievance",
          loadChildren: () => 
          import("../../views/pages/gievances/grievancedetailview/grievancedetailview.module").then(
            (m)=>m.GrievancedetailviewModule
          )
        },
      {
        path: "applicationgrievance",
        loadChildren: () => 
        import("../../views/pages/applicationgrievance/applicationgrivanceview/applicationgrivanceview.module").then(
          (m)=>m.ApplicationgrivanceviewModule
        )
      },
      {
        path: "inspection",
        loadChildren: () => 
        import("../../views/pages/inspection/inspection.module").then(
          (m)=>m.InspectionModule
        )
      },
      {
        path: "grievanceReport",
        loadChildren: () => 
        import("../../views/pages/reports/reports.module").then(
          (m)=>m.ReportsModule
        )
      },
      {
        path: "inspectionReport",
        loadChildren: () => 
        import("../../views/pages/reports/inspection-report/inspectionreport.module").then(
          (m)=>m.InspectionreportModule
        )
      },
      {
        path: "feedback",
        loadChildren: () => 
        import("../../views/pages/feedback/feedback.module").then(
          (m)=>m.FeedbackModule
        )
      },
      {
        path: "grievances",
        loadChildren: () => 
        import("../../views/pages/bvg/bvg.module").then(
          (m)=>m.BvgModule
        )
      },
      {
        path: "grievances/:id/:actionInfo",
        loadChildren: () => 
        import("../../views/pages/bvg/bvg.module").then(
          (m)=>m.BvgModule
        )
      },
      {
        path: "pdfupload",
        loadChildren: () => 
        import("../../views/pages/pdfuploader/pdfuploader.module").then(
          (m)=>m.PdfuploaderModule
        )
      },
      {
        path: "supervisor",
        loadChildren: () => 
        import("../../views/pages/bvg/bvg.module").then(
          (m)=>m.BvgModule
        )
      },
      // {
      //   path: "locationoffacilities",
      //   loadChildren: () => 
      //   import("../../views/pages/locationfacilities/locationfacilities.module").then(
      //     (m)=>m.LocationfacilitiesModule
      //   )
      // }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule { }
